import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-sizing: border-box;\n  min-width: 290px;\n  width: calc(100% - 60px);\n  border-radius: ", ";\n  position: relative;\n  padding-bottom: 10px;\n  margin-left: auto;\n  margin-right: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../utils/styling/styled-components';
import { BaseModal } from '../Modal';
import { LearnTipContent } from './LearnTipContent';
var TipBody = styled.div(_templateObject(), function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.borderRadius.large;
});
export var LearnTipModal = function LearnTipModal(_ref) {
  var isOpen = _ref.isOpen,
      step = _ref.step,
      handleClose = _ref.handleClose;

  var learnTipStep = _objectSpread(_objectSpread({}, step), {}, {
    content: step.body
  });

  return /*#__PURE__*/React.createElement(BaseModal, {
    hasOverlayBackground: true,
    isOpen: isOpen,
    onRequestClose: handleClose
  }, /*#__PURE__*/React.createElement(TipBody, null, /*#__PURE__*/React.createElement(LearnTipContent, {
    step: learnTipStep,
    handleClose: handleClose
  })));
};